
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../common/client/components/Text';

import { getToken } from '../../reducers/auth';
import { getProjectId } from '../../reducers/project'
import searchGetActions from '../../sagas/search';

const classNames = mergeStyleSets({
    root: {
    }
});

const ObjectInfoSearch = (props) => {

    const [params, setParams] = useState({});

    const dispatch = useDispatch();
    const searchActions = searchGetActions(dispatch);

    const token = useSelector(state => getToken(state));
    const projectId = useSelector(state => getProjectId(state));

    const search = useSelector(state => {
        return state.search;
    });

    useEffect(() => {
        if (!search.params && !search.loading) {
            searchActions.getParams(token, projectId, props.searchType);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const handleChangeParams = (params) => {
        setParams(params);
    }

    const handleSearchClick = () => {
        searchActions.runSearch(token, projectId, props.searchType, params);
    }

    return (
        <div className={classNames.root}>
            <Stack tokens={{childrenGap: 16}}>
                <Stack.Item>
                    {React.createElement(
                        props.paramsClass,
                        {
                            params: search.params,
                            loading: search.loading,
                            onChangeParams: handleChangeParams,
                            onSearchClick: handleSearchClick
                        }
                    )}
                </Stack.Item>
                <Stack.Item grow>
                    {search.searchResult
                        ? (search.searchResult.length > 0)
                            ? React.createElement(
                                props.resultClass,
                                {
                                    ...(props.resultProps || {}),
                                    [props.resultPropName]: search.searchResult
                                }
                            )
                            : <Text>Podle zadaných parametrů nebylo nic vyhledáno</Text>
                        : null
                    }

                </Stack.Item>
            </Stack>
        </div>
    );
}

export default ObjectInfoSearch;
